import { render, staticRenderFns } from "./TrainingStatisticsBar.vue?vue&type=template&id=063244b8&scoped=true"
import script from "./TrainingStatisticsBar.vue?vue&type=script&lang=js"
export * from "./TrainingStatisticsBar.vue?vue&type=script&lang=js"
import style0 from "./TrainingStatisticsBar.vue?vue&type=style&index=0&id=063244b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063244b8",
  null
  
)

export default component.exports